<div class="checkout-section section-active" id="payment-section">
  <div class="payment-methods">
    @for (paymentTypes of paymentTypes$ | async; track paymentTypes) {
      <div class="payment-method"
        [class.selected]="selectedPaymentMethod === paymentTypes.code" (click)="onPaymentChange(paymentTypes.code)" [ngClass]="{ 'pay-option-disabled': disableAccountOption && paymentTypes.code === 'ACCOUNT' }">
        <input type="radio" name="payment-method" [value]="paymentTypes.code" [(ngModel)]="selectedPaymentMethod" [disabled]="disableAccountOption && paymentTypes.code === 'ACCOUNT'" >
        <div class="payment-icon">
          {{ paymentTypes.code === 'CARD' ? '💳' : paymentTypes.code === 'ACCOUNT' ? '🏢' : '' }}
        </div>
        <div class="payment-content">
          <div class="payment-title">{{ paymentTypes.displayName }}</div>
          <div class="payment-desc">
            {{ paymentTypes.code === 'CARD'
            ? 'Secure payment with major credit cards'
            : 'Use your company’s credit account for this purchase' }}
          </div>
          @if (paymentTypes.code === 'CARD') {
            <div class="card-logos">
              <div class="card-logo">VISA</div>
              <div class="card-logo">MC</div>
              <div class="card-logo">AMEX</div>
              <div class="card-logo">DISC</div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  @if (selectedPaymentMethod === 'ACCOUNT') {
    <div class="account-form active">
      <div class="account-info-grid">
        <div class="account-info-item">
          <label class="form-label">Sold To Account</label>
          <div class="account-value">{{customerName}}</div>
        </div>
        <div class="account-info-item">
          <label class="form-label">Account Number</label>
          <div class="account-value">{{customerNumber}}</div>
        </div>
      </div>
    </div>
  }

  @if (payMetricIframeSource && selectedPaymentMethod === 'CARD') {
    <div>
      @if (isPayment) {
        <form [formGroup]="billingForm" class="billing-address-form" >
          <div class="">
            <h4>Billing Address</h4>
            <div class="form-row">
              <div class="form-group" [ngClass]="{'has-error': isInvalid('firstName')}">
                <label for="first-name">{{'checkoutPickup.form.firstName' | cxTranslate}} <span class="required">*</span></label>
                <input id="first-name" class="form-input" maxlength="30" formControlName="firstName" required>
                <cx-form-errors [control]="billingForm.get('firstName')"></cx-form-errors>
              </div>
              <div class="form-group" [ngClass]="{'has-error': isInvalid('lastName')}">
                <label for="last-name">{{'checkoutPickup.form.lastName' | cxTranslate}} <span class="required">*</span></label>
                <input id="last-name" maxlength="30" class="form-input" formControlName="lastName" required>
                <cx-form-errors [control]="billingForm.get('lastName')"></cx-form-errors>
              </div>
            </div>
            <div class="form-group full-width" [ngClass]="{ 'has-error': isInvalid('line1') }">
              <label for="delivery-address">{{'checkoutDeliveryAddress.form.line1' | cxTranslate}}
                <span class="required">*</span></label>
                <input id="delivery-address" maxlength="45" class="form-input" formControlName="line1" required>
                <cx-form-errors [control]="billingForm.get('line1')"></cx-form-errors>
              </div>
              <div class="form-group full-width">
                <label for="address-line-2">{{'checkoutDeliveryAddress.form.line2' | cxTranslate}}
                  <span>(optional)</span></label>
                  <input maxlength="30" id="address-line-2" class="form-input" formControlName="line2">
                </div>
                <div class="row m-0">
                  <div class="col-4 p-0" [ngClass]="{ 'has-error': isInvalid('town') }">
                    <label for="town">{{'checkoutDeliveryAddress.form.city' | cxTranslate}} <span class="required">*</span></label>
                    <input maxlength="30" id="town" class="form-input" formControlName="town" required>
                    <cx-form-errors [control]="billingForm.get('town')"></cx-form-errors>
                  </div>
                  <div class="col-4 p-0" [ngClass]="{ 'has-error': isInvalid('region') }">
                    <label for="region">{{'checkoutDeliveryAddress.form.state' | cxTranslate}} <span class="required">*</span></label>
                    <ng-select id="region" [items]="stateData" bindLabel="name" bindValue="isocode" formControlName="region" placeholder="">
                    </ng-select>
                    <cx-form-errors [control]="billingForm.get('region')"></cx-form-errors>
                  </div>
                  <div class="col-4" [ngClass]="{ 'has-error': isInvalid('postalCode')}">
                    <label for="zip-code">{{'checkoutDeliveryAddress.form.zipCode' | cxTranslate}} <span class="required">*</span></label>
                    <input id="zip-code" class="form-input pr-2" maxlength="5" formControlName="postalCode" required>
                    <cx-form-errors [control]="billingForm.get('postalCode')"></cx-form-errors>
                  </div>
                </div>
              </div>
              @if (billingFormInvalid) {
                <h4 class="zip-error-message pt-2">Please enter the missing details in the billing address section.</h4>
              }
            </form>
          }
          @if (isPayment) {
            <div class="embedded-paymetric-container show">
              <div class="embedded-iframe-header">
                <span>Paymetric Secure Payment Entry</span>
              </div>
              <div class="embedded-iframe-form">
                <ng-container>
                  <iframe id="xiFrameHosted" name='xieCommFrame' class="custom-iframe" [src]="payMetricIframeSource"></iframe>
                  <br>
                    <button id="cmdSubmit2" (click)="submitServiceForm($event);" type="button" class="btn btn-primary btn-block checkout-next">
                      Submit
                    </button>
                  </ng-container>
                </div>
              </div>
            }
          </div>
        }

        <div class="embedded-security-info">
          🛡️ Your payment data is securely encrypted. Card details are not stored on the merchant's servers and process securely by Paymetric.
        </div>
        @if (!isPayment) {
          <div class="payment-complete-message"  >
            <div >
              <strong  class="credit-card">Credit Card Validated Successfully!</strong>
              <div  class="card-container">
                <div class="sub-container">
                  <span class="card-ending">Card ending in:</span>
                  <strong class="last-four-digits"> •••• •••• •••• {{cardInfo.cardNumber}}</strong>
                </div>
                <div class="expire-container">
                  <span  class="expires">Expires:</span>
                  <strong class="expiry-display"> {{cardInfo.expiryMonth}}/{{cardInfo.expiryYear}}</strong>
                </div>
              </div>
              <div class="process">
                Your payment method has been verified and is ready for processing.
              </div>
            </div>
          </div>
        }

        <p class=" footnote">
          We are required by law to charge all applicable sales taxes for online orders.
          Please note that the order totals during your checkout reflect estimated sales tax. The actual charge to your
          form of payment will include applicable state and local sales taxes and will be calculated when order is
          shipped.
        </p>
      </div>